const state = {
  widgets: {
    vehicle_status: { loading: true, is_empty: true },
    fleet_kms: { loading: true, is_empty: true },
    best_kms: { loading: true, is_empty: true },
    vehicle_violations: { loading: true, is_empty: true },
    best_speeds: { loading: true, is_empty: true },
    best_violations: { loading: true, is_empty: true },
    worst_violations: { loading: true, is_empty: true },
  },
};

const mutations = {
  change_data(state, data) {
    state.widgets[data.widget_name] = { ...data };
  },
};

const actions = {
  change_widget_data({ commit }, data) {
    commit('change_data', data);
  },
};

const getters = {
  widgets(state) {
    return state.widgets;
  },
  widget_state_information(state) {
    return widget_name => {
      return state.widgets[widget_name];
    };
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
